module.exports = __webpack_public_path__ + "static/img/华为智慧屏V5.4e8fee7b.png";